<template>
	<div class="about">
		<img class="wow fadeIn" style="width: 100%;" src="../../assets/businessBg.jpg" />
		<div class="mainArea ">
			<div class="threeGod flexBtw wow bounceInDown ">
				<div class="lightBoxImportant2"><img src="../../assets/three_1.png" />
					<div>精品内容</div>
				</div>
				<div class="lightBoxImportant"><img src="../../assets/three_2.png" />
					<div>娱乐新空间</div>
				</div>
				<div class="lightBoxImportant2"><img src="../../assets/three_3.png" />
					<div>数字营销</div>
				</div>
			</div>
			<div class="threeGod2 wow bounceInUp">				
				<div class="lightBox">
					<p class="a">深耕<label class="b">娱乐新空间</label>运营</p>
					<p class="a">并在上下游布局<label class="b">内容投资</label>和<label class="b">数字营销</label></p>
				</div>
				<div class="itemBox" ref="demo2">
					<div class="itemBox_a">
						<div class="title ">娱乐新空间</div>
						<div class="info ">“体验经济”时代，基于特定物理空间的娱乐业态迎来爆发机遇<br>
							当前聚焦传统电影院向演艺新空间、VR剧院的发展<br>
							持续产品迭代，致力于服务更广阔的商业、文化空间和城市更新
						</div>
					</div>
					<div class="itemBox_b">
						<el-carousel trigger="click" :height="mheight" :interval='5000'>
							<el-carousel-item >
								<img class="itemBox_bimg" src="../../assets/team_3.jpg" />
							</el-carousel-item>
							<el-carousel-item>
								<img  class="itemBox_bimg" src="../../assets/team_4.jpg" />
							</el-carousel-item>
							<el-carousel-item>
								<img  class="itemBox_bimg" src="../../assets/team2_0.jpg" />
							</el-carousel-item>
							<el-carousel-item>
								<img  class="itemBox_bimg" src="../../assets/team2_4.jpg" />
							</el-carousel-item>
							<el-carousel-item>
								<img  class="itemBox_bimg" src="../../assets/team2_1.jpg" />
							</el-carousel-item>
							<el-carousel-item>
								<img  class="itemBox_bimg" src="../../assets/team2_2.jpg" />
							</el-carousel-item>
							<el-carousel-item>
								<img  class="itemBox_bimg" src="../../assets/team2_3.jpg" />
							</el-carousel-item>
						</el-carousel>
					</div>										
				</div>
				<div class="itemBox" ref="demo1">					
					<div class="itemBox_b" ref="itemBox_bref">
						<el-carousel trigger="click" :height="mheight">
							<el-carousel-item >
								<img class="itemBox_bimg" src="../../assets/team_1.jpg"  />
							</el-carousel-item>
							<el-carousel-item>
								<img  class="itemBox_bimg" src="../../assets/team_2.jpg" />
							</el-carousel-item>
						</el-carousel>
					</div>
					<div class="itemBox_a">
						<div class="title">精品内容</div>
						<div class="info">内容为王<br>
							提升投资回报率，挖掘优质IP的长期价值<br>
							自微短剧、儿童剧等细分市场切入重点发力VR内容
						</div>
					</div>
				</div>				
				<div class="itemBox" ref="demo3">
					<div class="itemBox_a">
						<div class="title" >数字营销</div>
						<div class="info" >服务于精品内容发行、为娱乐新空间引流<br>							继续发挥互联网票务、数字营销等传统业务优势<br>
							战略性布局AI营销
						</div>
					</div>
					<div class="itemBox_b">
						<el-carousel trigger="click" :height="mheight" :interval='4000'>
							<el-carousel-item >
								<img class="itemBox_bimg" src="../../assets/team_5.jpg" />
							</el-carousel-item>
							<el-carousel-item>
								<img  class="itemBox_bimg" src="../../assets/team_6.png" />
							</el-carousel-item>
						</el-carousel>
					</div>										
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		WOW
	} from 'wowjs'
	export default {
		name: 'Home',
		data() {
			return {
				mheight:'',
				pcShow:true
			}
		},
		created() {
			let isM=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
			if(isM){
				this.$router.push({ path: '/mobile/business'});
			}
		},
		methods:{
			scrollToElement(name) {
			  const element = this.$refs[name];
			  if (element) {
			          const rect = element.getBoundingClientRect();
			          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			          const targetPosition = rect.top + scrollTop - 100; // 减去100px作为偏移
			          
			          window.scrollTo({
			            top: targetPosition,
			            behavior: 'smooth'
			          });
			        }
			},
		},
		mounted() {
			const that = this
			if(window.innerWidth<=800){
				this.pcShow=false
			}
			const divWidth = this.$refs.itemBox_bref.offsetWidth;
			this.mheight=410*divWidth/570+'px'
			this.$nextTick(() => {
				let demoType=that.$route.query.demoType
				if(demoType){
					setTimeout(()=>{
						that.scrollToElement('demo'+demoType)
					},500)					
				}	
				const wow = new WOW({
					boxClass: 'wow',
					animateClass: 'animated',
					offset: 0,
					mobile: true,
					live: true,
				})
				wow.init()
			})
		}
	}
</script>
<style lang="less" scoped>
	.lightBoxImportant{
		background: #FB5400;
		padding: 20px;
		border-radius: 5px;
	}
	.lightBoxImportant2{
		border:1px solid #777;
		padding: 20px;
		border-radius: 5px;
	}
	.threeGod {
		margin: 50px auto;
		width: 1000px;
		color: #fff;
		font-size: 20px;
		font-weight: bold;
		img {
			margin-bottom: 20px;
		}
	}
	.lightBox{
		position: relative;
		overflow: hidden;
		padding-bottom: 80px;
	}
	.light-1 {
		position: absolute;
		z-index: 0;
		width: 1000px;
		height: 1000px;
		border-radius: 50%;
		filter: blur(80px);
		animation: moveAround 10s linear infinite;
		background: rgba(106, 0, 255, 0.4);
		top: 10px;
		left: calc(50% - 500px);
		animation-delay: 0s;
	}
	.itemBox{
		display: flex;
		align-items: center;
		background: #fff;
		justify-content: space-between;
		margin-bottom: 30px;		
		.itemBox_a{
			flex-shrink: 0;			
			width: 50%;
			padding: 40px;
			text-align: left;
			.title{
				color: #333;
				font-size: 30px;
				margin-bottom: 10px;
			}
			.info{
				line-height: 30px;
				color: #777;
				font-size: 16px;
			}
		}
		.itemBox_b{
			width: 50%;
			.itemBox_bBox{
				height: 800px;
			}
			.itemBox_bimg{
				width: 100%;
				height: auto;
				background: darkblue;
			}
		}
	}
	.threeGod2 {
		position: relative;
		padding-top: 30px;
		border-top: 1px solid #333;
		font-size: 30px;
		background: url('../../assets/Polygon 1.png') no-repeat top center;
		background-size: 100% auto;

		.a {
			line-height: 80px;
		}

		.b {
			color: #FB5400;
		}
	}

	@media (max-width:1440px) {
		.threeGod {
			margin-top: 80px;
			width: 500px;
		}
		
		.itemBox{
			.itemBox_a{
				.title{
					font-size: 20px;
				}
				.info{
					font-size: 14px;
				}
			}
		}
	}
	@media (max-width:800px) {
		.threeGod {
			margin-top: 50px;
			width: 300px;
			font-size: 14px;
			img{
				height: 30px;
			}
		}
		.threeGod2 {
			.a {
				font-size: 24px;
				line-height: 50px;
			}
		}
		.itemBox{
			display: block;
			.itemBox_a{
				width: 100%;
				padding: 20px;
			}
			.itemBox_b{
				width: 100%;
				.itemBox_bBox{
					height: 800px;
				}
			}
		}
	}
</style>